(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('personalized-product-confirmation')) {
    class PersonalizedProductConfirmation extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.dialog = this.querySelector('dialog');
        this.checkbox = this.querySelector('[data-personalized-confirmation-checkbox]');
        this.confirmButton = this.querySelector('[data-personalized-confirmation-confirm]');
        this.cancelButton = this.querySelector('[data-personalized-confirmation-cancel]');
        this.propertyInput = this.querySelector('[data-personalized-confirmation-property]');
        this.confirmed = false;

        if (!this.form || !this.dialog || !this.checkbox || !this.confirmButton || !this.cancelButton || !this.propertyInput) {
          return;
        }

        this.handleSubmit = this.onSubmit.bind(this);
        this.handleCheckbox = this.onCheckboxChange.bind(this);
        this.handleConfirm = this.onConfirm.bind(this);
        this.handleCancel = this.onCancel.bind(this);
        this.handleDialogCancel = this.onDialogCancel.bind(this);

        this.form.addEventListener('submit', this.handleSubmit, true);
        this.checkbox.addEventListener('change', this.handleCheckbox);
        this.confirmButton.addEventListener('click', this.handleConfirm);
        this.cancelButton.addEventListener('click', this.handleCancel);
        this.dialog.addEventListener('cancel', this.handleDialogCancel);
      }

      disconnectedCallback() {
        if (!this.form) {
          return;
        }

        this.form.removeEventListener('submit', this.handleSubmit, true);
        this.checkbox?.removeEventListener('change', this.handleCheckbox);
        this.confirmButton?.removeEventListener('click', this.handleConfirm);
        this.cancelButton?.removeEventListener('click', this.handleCancel);
        this.dialog?.removeEventListener('cancel', this.handleDialogCancel);
      }

      onSubmit(event) {
        if (this.confirmed) {
          this.confirmed = false;
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        this.submitter = event.submitter;
        this.dialog.showModal();
        this.checkbox.focus();
      }

      onCheckboxChange() {
        this.confirmButton.disabled = !this.checkbox.checked;
      }

      onConfirm() {
        if (!this.checkbox.checked) {
          return;
        }

        this.propertyInput.disabled = false;
        this.confirmed = true;
        this.dialog.close();

        if (this.submitter?.isConnected) {
          this.form.requestSubmit(this.submitter);
        } else {
          this.form.requestSubmit();
        }
      }

      onCancel() {
        this.closeDialog();
      }

      onDialogCancel(event) {
        event.preventDefault();
        this.closeDialog();
      }

      closeDialog() {
        this.dialog.close();
        this.checkbox.checked = false;
        this.confirmButton.disabled = true;
        this.submitter?.focus();
      }
    }

    customElements.define('personalized-product-confirmation', PersonalizedProductConfirmation);
  }
  } catch(e) { console.error(e); }
})();

})();
